import React from 'react';
import { string } from 'prop-types';
import { BrowserRouter } from 'react-router-dom';
import App from '../../../pages/signup/components/App';

const AffiliatesSignup = ({ basename }) => (
  <BrowserRouter basename={basename}>
    <App />
  </BrowserRouter>
);

AffiliatesSignup.propTypes = {
  basename: string,
};

export default AffiliatesSignup;
